import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import {
  RequestAccessContentService,
  CommonContentService
} from '@tmhcc-ng-lib/content-service';
import { CoreInputValidationService } from '@tmhcc-ng-lib/framwork/core-inputs';
import { InputConfig } from '@tmhcc-ng-lib/framwork/form-inputs';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { Subscription } from 'rxjs';
import { supportConfigInfo } from './support-request-field-config';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { getBaseUri } from '@tmhcc/util';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'ae-support-request',
  templateUrl: './support-request.component.html',
  styleUrls: ['./support-request.component.scss']
})
export class SupportRequestComponent extends supportConfigInfo
  implements OnInit {
  buttonLabel: string;
  requestAccessReturnUrl: string;
  valueSub = new Subscription();
  frmGroup: FormGroup;
  supportRequestField: InputConfig[];
  phoneRequestField: InputConfig[];
  emailRequestField: InputConfig[];
  supportRequestProduct: InputConfig[];
  premiumProduct: InputConfig[];
  // companyRequestField: InputConfig[];
  supportFormControl: Object = {};
  pageTitle: string;
  pageDescription: string;
  formLabel;
  checkboxFlag: boolean = false;
  hasFormBeenSubmitted: boolean = false;
  radioSelected: boolean = false;
  accessRequestOriginate: string = null;
  oid;
  requestAccessUrl;
  lead_source;
  debug;
  debugEmail;
  first_name;
  last_name;
  company;
  city;
  RequestState;
  phone;
  email;
  tabLabel;
  access_request_origination;
  office_address;
  zip;
  business_agreement;
  requestFormLabel = {
    supportRequestLabel: '',
    companyRequestLabel: '',
    premiumProductLabel: ''
  };

  constructor(
    protected router: Router,
    protected activeRouter: ActivatedRoute,
    private formBuilder: FormBuilder,
    private validationService: CoreInputValidationService,
    private loaderService: LoaderService,
    private SiteCoreData: RequestAccessContentService,
    private configService: AppConfigService,
    private commonContentService: CommonContentService
  ) {
    super();
  }

  ngOnInit(): void {
    this.commonContentService.setPageTitle();
    this.requestAccessReturnUrl = getBaseUri() + '/thank-you';
    this.setEntity();
    this.loaderService.show();
    this.setFormControl(
      this.supportRequestField,
      this.phoneRequestField,
      this.emailRequestField,
      this.supportRequestProduct,
      this.premiumProduct,
      // this.companyRequestField
    );
    this.loaderService.show();
    this.requestAccessSiteCoreData();
    this.loaderService.show();
    this.frmGroup.controls['00N6g00000TXa9h'].valueChanges.subscribe(data => {
      this.radioSelected = data != '' ? true : false;
    });
    this.activeRouter.paramMap.subscribe(params => {
      this.accessRequestOriginate = params.get('value').toLowerCase();  
      if(this.accessRequestOriginate !=null){
        if(!(this.accessRequestOriginate=="appulate" || this.accessRequestOriginate=="ivans" || this.accessRequestOriginate=="vertafore")){
          this.router.navigate(['/login']);
        }
      }    
   })
  }
  requestAccessSiteCoreData() {
    this.SiteCoreData.data$.subscribe(res => {
      if (res) {
        this.buttonLabel = res.buttons[0]?.keyText;
        this.setCnValue(res);
        this.tabLabel = res.tabLabels[0].displayItems;
        this.requestFormLabel.supportRequestLabel =
          res.tabLabels[0].displayItems[0].description;
/*         this.requestFormLabel.companyRequestLabel =
          res.tabLabels[0].displayItems[1].description;
 */        
        this.requestFormLabel.premiumProductLabel =
          res.tabLabels[0].displayItems[1].description;

        this.oid = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.oid
        );
        this.requestAccessUrl = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.retURL
        );
        this.lead_source = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.lead_source
        );
        this.debug = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.debug
        );
        this.debugEmail = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.debugEmail
        );
        this.first_name = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.first_name
        );
        this.last_name = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.last_name
        );
        this.company = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.company
        );
        this.city = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.city
        );
        this.RequestState = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.RequestState
        );
        this.zip = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.zip
        );
        this.phone = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.phone
        );
        this.email = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.email
        );
        this.office_address = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.office_address
        );
        this.access_request_origination = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.access_request_origination
        );
        this.business_agreement = res.forms[1].fields.find(
          items => items.fieldInfo.fieldName == this.cn.business_agreement
        );

        this.loaderService.hide();
        this.pageTitle = res.data[0].heading;
        this.pageDescription = res.data[0].description;

        this.setValidationforForm(
          res,
          this.phoneRequestField,
          this.emailRequestField,
          this.supportRequestField,
          this.supportRequestProduct,
          this.premiumProduct
        );
        this.supportRequestField.forEach(field => {
          if (field.fieldInfo.fieldName === 'RequestState1') {
            field.config.selectConfig.options = res.states;
          }
        });
      }
    });
  }
  setCnValue(data) {
    this.cn.oid = data.forms[1].fields[0]?.fieldInfo.fieldName;
    this.cn.retURL = data.forms[1].fields[1]?.fieldInfo.fieldName;
    this.cn.lead_source = data.forms[1].fields[2]?.fieldInfo.fieldName;
    this.cn.debug = data.forms[1].fields[3]?.fieldInfo.fieldName;
    this.cn.debugEmail = data.forms[1].fields[4]?.fieldInfo.fieldName;
    this.cn.first_name = data.forms[1].fields[5]?.fieldInfo.fieldName;
    this.cn.last_name = data.forms[1].fields[6]?.fieldInfo.fieldName;
    this.cn.company = data.forms[1].fields[7]?.fieldInfo.fieldName;
    this.cn.office_address = data.forms[1].fields[8]?.fieldInfo.fieldName;
    this.cn.city = data.forms[1].fields[9]?.fieldInfo.fieldName;
    this.cn.RequestState = data.forms[1].fields[10]?.fieldInfo.fieldName;
    this.cn.zip = data.forms[1].fields[11]?.fieldInfo.fieldName;
    this.cn.phone = data.forms[1].fields[12]?.fieldInfo.fieldName;
    this.cn.email = data.forms[1].fields[13]?.fieldInfo.fieldName;
    this.cn.access_request_origination = data.forms[1].fields[14]?.fieldInfo.fieldName;
    this.cn.business_agreement = data.forms[1].fields[15]?.fieldInfo.fieldName;
  }
  setValidationforForm(
    siteCoreData,
    phoneRequestField,
    emailRequestField,
    supportRequestField,
    supportRequestProduct,
    premiumProduct
  ) {
    let requiredValidation;
    let validationMessage;
    supportRequestField.forEach((element: InputConfig) => {
      let userFieldName = siteCoreData.forms[0].fields.filter(
        x => x.fieldInfo.fieldName + '1' === element.fieldInfo.fieldName
      );
      console.log("fieldName = ", element.fieldInfo.fieldName);
      if (userFieldName.length) {
        element.fieldInfo.label = userFieldName[0].fieldInfo.label;
      }
      if (element.fieldInfo.validations) {
        requiredValidation = element.fieldInfo.validations.filter(
          x => x.key === 'required'
        );
        let userRequestField = siteCoreData.forms[0].fields.filter(
          x => x.fieldInfo.label === element.fieldInfo.label
        );
        if (userRequestField) {
          validationMessage = userRequestField[0].fieldInfo.validations.filter(
            x => x.key === 'Required'
          );

          requiredValidation[0].value =
            userRequestField[0].fieldInfo.label +
            ' ' +
            validationMessage[0].value;
        }
      }
    });
    emailRequestField.forEach((element: InputConfig) => {
      let userFieldName = siteCoreData.forms[0].fields.filter(
        x => x.fieldInfo.fieldName + '1' === element.fieldInfo.fieldName
      );
      if (userFieldName) {
        element.fieldInfo.label = userFieldName[0].fieldInfo.label;
      }
      if (element.fieldInfo.validations) {
        requiredValidation = element.fieldInfo.validations.filter(
          x => x.key === 'required'
        );
        let emailField = siteCoreData.forms[0].fields.filter(
          x => x.fieldInfo.label === element.fieldInfo.label
        );
        if (emailField) {
          validationMessage = emailField[0].fieldInfo.validations.filter(
            x => x.key === 'Required'
          );
          requiredValidation[0].value =
            emailField[0].fieldInfo.label + ' ' + validationMessage[0].value;
        }
      }
    });
    phoneRequestField.forEach((element: InputConfig) => {
      let userFieldName = siteCoreData.forms[0].fields.filter(
        x => x.fieldInfo.fieldName + '1' === element.fieldInfo.fieldName
      );
      if (userFieldName) {
        element.fieldInfo.label = userFieldName[0].fieldInfo.label;
      }
      if (element.fieldInfo.validations) {
        requiredValidation = element.fieldInfo.validations.filter(
          x => x.key === 'required'
        );
        let phoneField = siteCoreData.forms[0].fields.filter(
          x => x.fieldInfo.label === element.fieldInfo.label
        );
        if (phoneField) {
          validationMessage = phoneField[0].fieldInfo.validations.filter(
            x => x.key === 'Required'
          );
          requiredValidation[0].value =
            phoneField[0].fieldInfo.label + ' ' + validationMessage[0].value;
        }
      }
    });
    supportRequestProduct.forEach((element: InputConfig) => {
      let userFieldName = siteCoreData.forms[0].fields.filter(
        x => x.fieldInfo.fieldName === element.fieldInfo.fieldName
      );
      if (userFieldName) {
        element.fieldInfo.label = userFieldName[0].fieldInfo.label;
        this.checkboxFlag = true;
      }
    });
  }

  setEntity() {
    this.supportRequestField = this.quoteInformationConfig.quoteFieldConfig;
    this.phoneRequestField = this.phoneRequestForm.phoneRequestFieldConfig;
    this.emailRequestField = this.emailRequestForm.emailRequestFieldConfig;
    this.supportRequestProduct = this.supportRequestProducts.supportRequestProductsFieldConfig;
    this.premiumProduct = this.premiumProducts.premiumFieldConfig;
    // this.companyRequestField = this.companyRequest.companyRequestFieldConfig;
  }
  setFormControl(
    supportRequestField,
    phoneRequestField,
    emailRequestField,
    supportRequestProduct,
    premiumProduct
    // companyRequestField
  ) {
    supportRequestField.forEach((element: InputConfig) => {
      let validators;

      if (element.config && element.config.validation) {
        validators = element.config.validation;
      } else {
        validators = null;
      }
      if (element.fieldInfo.fieldName !== 'RequestState1') {
        this.supportFormControl[element.fieldInfo.fieldName] = [
          '',
          Validators.compose(validators)
        ];
      } else {
        this.supportFormControl[element.fieldInfo.fieldName] = [
          null,
          Validators.compose(validators)
        ];
      }
    });

    phoneRequestField.forEach((element: InputConfig) => {
      let validators;
      if (element.config && element.config.validation) {
        validators = element.config.validation;
      } else {
        validators = null;
      }
      this.supportFormControl[element.fieldInfo.fieldName] = [
        '',
        Validators.compose(element.config.validation)
      ];
    });
    emailRequestField.forEach((element: InputConfig) => {
      let validators;
      if (element.config && element.config.validation) {
        validators = element.config.validation;
      } else {
        validators = null;
      }
      this.supportFormControl[element.fieldInfo.fieldName] = [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(
            '[_a-z0-9]+(.[_a-z0-9]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$'
          )
        ])
      ];
    });

    supportRequestProduct.forEach((element: InputConfig) => {
      let validators;
      if (element.config && element.config.validation) {
        validators = element.config.validation;
      } else {
        validators = null;
      }
      this.supportFormControl[element.fieldInfo.fieldName] = [
        '',
        Validators.compose(validators)
      ];
    });
    premiumProduct.forEach((element: InputConfig) => {
      let validators;
      if (element.config && element.config.validation) {
        validators = element.config.validation;
      } else {
        validators = null;
      }
      this.supportFormControl[element.fieldInfo.fieldName] = [
        '',
        Validators.compose(validators)
      ];
    });
/*     companyRequestField.forEach((element: InputConfig) => {
      let validators;
      if (element.config && element.config.validation) {
        validators = element.config.validation;
      } else {
        validators = null;
      }
      this.supportFormControl[element.fieldInfo.fieldName] = [
        '',
        Validators.compose(validators)
      ];
    }); */

    this.frmGroup = this.formBuilder.group(this.supportFormControl);
  }
  get f() {
    return this.frmGroup.controls;
  }
  saveSupportRequest(event, formGroup: NgForm) {
    this.loaderService.hide();
    this.validationService.setFormSubmission(true);
    this.hasFormBeenSubmitted = true;
    const radioValue = formGroup.form.controls['00N6g00000TXa9h'].value;
    if (this.frmGroup.valid) {
      this.radioSelected = true;
      this.copyInputValue(this.cn.first_name);
      this.copyInputValue(this.cn.last_name);
      this.copyInputValue(this.cn.company);
      this.copyInputValue(this.cn.office_address);
      this.copyInputValue(this.cn.city);
      this.copyInputValue(this.cn.RequestState);
      this.copyInputValue(this.cn.zip);
      this.copyInputValue(this.cn.phone);
      this.copyInputValue(this.cn.email);
      this.copyInputValue(this.cn.business_agreement);

      const checkboxes = [
        '00N6g00000TXa0v',
        '00N6g00000TXa0v',
        '00N6g00000TXa0v',
        '00N6g00000TXa0v',
        '00N6g00000TXa0v',
        '00N6g00000TXa0v'
      ];

      this.createCheckBox(checkboxes);
      (document.getElementById(
        'RequestState'
      ) as HTMLInputElement).value = (document
        .getElementById('RequestState1')
        .querySelector('.ng-value-label') as HTMLElement).innerText;
      this.loaderService.hide();
      event.target.submit();
    } else {
      if (radioValue === '') {
        this.radioSelected = false;
      }
    }
  }
  copyInputValue(id) {
    const id_form = id + '1';
    if (document.getElementById(id) && document.getElementById(id_form)) {
      (document.getElementById(
        id
      ) as HTMLFormElement).value = (document.getElementById(
        id_form
      ) as HTMLFormElement).value;
    }
  }

  createCheckBox(names: string[]) {
    names.forEach((name, i) => {
      const index = i == 0 ? '' : i;
      const checkbox = document.createElement('input');
      checkbox.setAttribute('type', 'checkbox');
      checkbox.setAttribute('type', 'hidden');

      if ($('#request-access') && $('#' + name + index)) {
        const element = $('#' + name + index);
        const isChecked = element.prop('checked');
        const value = element.attr('title');

        checkbox.setAttribute('name', name);
        checkbox.setAttribute('value', value);

        if (isChecked) {
          $('#request-access').prepend(checkbox);
        }
      }
    });
  }
}
